// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
        body {
          /* text-align: center; */
          margin-left: 50px;
          margin-right: 50px;
      
        }
        table {
          border-collapse: collapse;
          width: 50%;
          margin: 0 auto;
          border: '2px solid black' ;
        }
        th, td {
          border: 1px solid #dddddd;
          text-align: center;
          padding: 8px;
        }
        th {
          background-color: #f2f2f2;
        }

        /* record.css */

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 0 auto;
  }
  
  th, td {
    border: 1px solid #dddddd;
    text-align: center;
    padding: 8px;
  }
  
  th {
    background-color: #f2f2f2;
  }
  
  /* Add this class to hide elements */
  .hidden {
    display: none;
  }
  .loading-central-circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: relative;
    margin: 0 auto;
    animation: spin 1.5s linear infinite;
  }
  
  .loading-central-circle::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 10px solid transparent;
    border-top-color: #FF0000; /* Red */
    border-bottom-color: #2eccd1; /* Gold */
    animation: spin 2s linear infinite reverse;
  }
  
  .loading-central-circle::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 10px solid transparent;
    border-top-color: #FFD700; /* Gold */
    border-bottom-color: #008000; /* Green */
    animation: spin 3s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .hidden {
    display: none;
  }





  @media print {
    button {
    display: none;
    }
    h4{
    text-align: center;
    }
    *{
      margin: 0px;
      font-size: 12px;
    }
    
    }

  








    


    .hover-table {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-38%, -50%);
      background-color: white;
      border: 1px solid #ccc;
      width: 1000px;/* Set the desired width */
      max-height: 500px; /* Set the desired height */
      overflow: auto;
    }
    
    .hover-table table {
      width: 100%;
      height: 100%;
      border-collapse: collapse;
    }
    
    .hover-table th,
    .hover-table td {
      padding: 8px;
      border: 1px solid #ddd;
    }
    
    .hover-table th {
      background-color: #f2f2f2;
      position: sticky;
      top: 0%;
    }
    
    .hover-table tbody tr:nth-child(even) {
      background-color: #f2f2f2;
    }
    
    .hover-table tbody tr:hover {
      background-color: #ddd;
    }
    
    



    @keyframes textColorCycle {
      0% { color: #d62929; }
      25% { color: #27d627; }
      50% { color: #6666f5; }
      75% { color: #dfdf41; }
      100% { color: #641818; }
    }
    
    .animated-th {
      animation: textColorCycle 3s infinite;
      cursor: pointer;
    }
 


    @keyframes textColorCycle1 {
      100% { color: #641818; }
      75% { color: #dfdf41; }
      50% { color: #6666f5; }
      25% { color: #27d627; }
      0% { color: #d62929; }
    }
    
    .animated-th1 {
      animation: textColorCycle1 3s infinite;
      cursor: pointer;
    }

    `, "",{"version":3,"sources":["webpack://./src/components/client/record.css"],"names":[],"mappings":";QACQ;UACE,wBAAwB;UACxB,iBAAiB;UACjB,kBAAkB;;QAEpB;QACA;UACE,yBAAyB;UACzB,UAAU;UACV,cAAc;UACd,0BAA0B;QAC5B;QACA;UACE,yBAAyB;UACzB,kBAAkB;UAClB,YAAY;QACd;QACA;UACE,yBAAyB;QAC3B;;QAEA,eAAe;;EAErB;IACE,yBAAyB;IACzB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB,EAAE,QAAQ;IACnC,4BAA4B,EAAE,SAAS;IACvC,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB,EAAE,SAAS;IACpC,4BAA4B,EAAE,UAAU;IACxC,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;EACA;IACE,aAAa;EACf;;;;;;EAMA;IACE;IACA,aAAa;IACb;IACA;IACA,kBAAkB;IAClB;IACA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;;;;;;;;;;;;;;IAcA;MACE,eAAe;MACf,QAAQ;MACR,SAAS;MACT,gCAAgC;MAChC,uBAAuB;MACvB,sBAAsB;MACtB,aAAa,CAAC,0BAA0B;MACxC,iBAAiB,EAAE,2BAA2B;MAC9C,cAAc;IAChB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB;IAC3B;;IAEA;;MAEE,YAAY;MACZ,sBAAsB;IACxB;;IAEA;MACE,yBAAyB;MACzB,gBAAgB;MAChB,OAAO;IACT;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,sBAAsB;IACxB;;;;;;IAMA;MACE,KAAK,cAAc,EAAE;MACrB,MAAM,cAAc,EAAE;MACtB,MAAM,cAAc,EAAE;MACtB,MAAM,cAAc,EAAE;MACtB,OAAO,cAAc,EAAE;IACzB;;IAEA;MACE,qCAAqC;MACrC,eAAe;IACjB;;;;IAIA;MACE,OAAO,cAAc,EAAE;MACvB,MAAM,cAAc,EAAE;MACtB,MAAM,cAAc,EAAE;MACtB,MAAM,cAAc,EAAE;MACtB,KAAK,cAAc,EAAE;IACvB;;IAEA;MACE,sCAAsC;MACtC,eAAe;IACjB","sourcesContent":["\r\n        body {\r\n          /* text-align: center; */\r\n          margin-left: 50px;\r\n          margin-right: 50px;\r\n      \r\n        }\r\n        table {\r\n          border-collapse: collapse;\r\n          width: 50%;\r\n          margin: 0 auto;\r\n          border: '2px solid black' ;\r\n        }\r\n        th, td {\r\n          border: 1px solid #dddddd;\r\n          text-align: center;\r\n          padding: 8px;\r\n        }\r\n        th {\r\n          background-color: #f2f2f2;\r\n        }\r\n\r\n        /* record.css */\r\n\r\n  table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n  th, td {\r\n    border: 1px solid #dddddd;\r\n    text-align: center;\r\n    padding: 8px;\r\n  }\r\n  \r\n  th {\r\n    background-color: #f2f2f2;\r\n  }\r\n  \r\n  /* Add this class to hide elements */\r\n  .hidden {\r\n    display: none;\r\n  }\r\n  .loading-central-circle {\r\n    width: 100px;\r\n    height: 100px;\r\n    border-radius: 50%;\r\n    position: relative;\r\n    margin: 0 auto;\r\n    animation: spin 1.5s linear infinite;\r\n  }\r\n  \r\n  .loading-central-circle::before {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n    border: 10px solid transparent;\r\n    border-top-color: #FF0000; /* Red */\r\n    border-bottom-color: #2eccd1; /* Gold */\r\n    animation: spin 2s linear infinite reverse;\r\n  }\r\n  \r\n  .loading-central-circle::after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n    border: 10px solid transparent;\r\n    border-top-color: #FFD700; /* Gold */\r\n    border-bottom-color: #008000; /* Green */\r\n    animation: spin 3s linear infinite;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n  }\r\n  .hidden {\r\n    display: none;\r\n  }\r\n\r\n\r\n\r\n\r\n\r\n  @media print {\r\n    button {\r\n    display: none;\r\n    }\r\n    h4{\r\n    text-align: center;\r\n    }\r\n    *{\r\n      margin: 0px;\r\n      font-size: 12px;\r\n    }\r\n    \r\n    }\r\n\r\n  \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n    \r\n\r\n\r\n    .hover-table {\r\n      position: fixed;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-38%, -50%);\r\n      background-color: white;\r\n      border: 1px solid #ccc;\r\n      width: 1000px;/* Set the desired width */\r\n      max-height: 500px; /* Set the desired height */\r\n      overflow: auto;\r\n    }\r\n    \r\n    .hover-table table {\r\n      width: 100%;\r\n      height: 100%;\r\n      border-collapse: collapse;\r\n    }\r\n    \r\n    .hover-table th,\r\n    .hover-table td {\r\n      padding: 8px;\r\n      border: 1px solid #ddd;\r\n    }\r\n    \r\n    .hover-table th {\r\n      background-color: #f2f2f2;\r\n      position: sticky;\r\n      top: 0%;\r\n    }\r\n    \r\n    .hover-table tbody tr:nth-child(even) {\r\n      background-color: #f2f2f2;\r\n    }\r\n    \r\n    .hover-table tbody tr:hover {\r\n      background-color: #ddd;\r\n    }\r\n    \r\n    \r\n\r\n\r\n\r\n    @keyframes textColorCycle {\r\n      0% { color: #d62929; }\r\n      25% { color: #27d627; }\r\n      50% { color: #6666f5; }\r\n      75% { color: #dfdf41; }\r\n      100% { color: #641818; }\r\n    }\r\n    \r\n    .animated-th {\r\n      animation: textColorCycle 3s infinite;\r\n      cursor: pointer;\r\n    }\r\n \r\n\r\n\r\n    @keyframes textColorCycle1 {\r\n      100% { color: #641818; }\r\n      75% { color: #dfdf41; }\r\n      50% { color: #6666f5; }\r\n      25% { color: #27d627; }\r\n      0% { color: #d62929; }\r\n    }\r\n    \r\n    .animated-th1 {\r\n      animation: textColorCycle1 3s infinite;\r\n      cursor: pointer;\r\n    }\r\n\r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
